<template>
    <div class="services view">
        <nks-header></nks-header>
        <div class="content">
            <transition name="v-transition-main-views">
                <router-view></router-view>
            </transition>
        </div>
    </div>
</template>

<script>
    import Header from './Header.vue';

    export default {
        components: {
            nksHeader: Header
        },
    }
</script>


// WEBPACK FOOTER //
// Services.vue?ba624306